import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";

export default function About() {
    const { t } = useLang();
    return (
        <main
            className="max-w-4xl mx-auto px-5 md:px-8 pt-12 md:pt-20 pb-24 relative"
            data-testid="about-page"
        >
            <div className="glow glow-lime -top-10 -left-20" />
            <div className="relative z-10">
                <span className="tag">{t.about.tag}</span>
                <h1 className="font-display font-black text-white text-5xl md:text-7xl mt-4 uppercase leading-[0.92]">
                    {t.about.head_a}{" "}
                    <span className="font-brush text-[var(--coral)] inline-block -rotate-3">
                        {t.about.head_b}
                    </span>
                </h1>
                <div className="space-y-6 font-mono text-[var(--text)] mt-8 text-base md:text-lg leading-relaxed">
                    <p>{t.about.p1}</p>
                    <p>{t.about.p2}</p>
                    <h2 className="font-display font-bold text-[var(--lime)] text-2xl uppercase mt-10 mb-2">
                        {t.about.h2_a}
                    </h2>
                    <ul className="list-disc list-inside space-y-2">
                        <li>{t.about.l1}</li>
                        <li>{t.about.l2}</li>
                        <li>{t.about.l3}</li>
                        <li>{t.about.l4}</li>
                    </ul>
                    <h2 className="font-display font-bold text-[var(--cyan)] text-2xl uppercase mt-10 mb-2">
                        {t.about.h2_b}
                    </h2>
                    <p>{t.about.p3}</p>

                    <div className="mt-10 card p-6">
                        <p className="font-brush text-[var(--lime)] text-3xl -rotate-2 inline-block">
                            {t.about.quote}
                        </p>
                        <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--muted)] mt-3">
                            {t.about.quoteBy}
                        </p>
                    </div>

                    <div className="mt-10 flex gap-3 flex-wrap">
                        <Link to="/curriculum" className="btn-prime">
                            {t.about.startW1}
                        </Link>
                        <Link to="/teach" className="btn-ghost">
                            {t.about.teacherTools}
                        </Link>
                    </div>
                </div>
            </div>
        </main>
    );
}
